export const valueMaxDistanceSliderMap = (value: number): number => {
  switch (value) {
    case 0:
      return 100;
    case 10:
      return 200;
    case 20:
      return 500;
    case 30:
      return 1000;
    case 40:
      return 2000;
    case 50:
      return 3000;
    default:
      return 0;
  }
}